import React, { useEffect, useRef, useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import Breadcrumbs from '../components/Breadcrumbs';
import paginationFactory from 'react-bootstrap-table2-paginator';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import filterFactory, { textFilter, customFilter } from 'react-bootstrap-table2-filter';
import 'bootstrap/dist/css/bootstrap.css';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import configData from '../configData.json';
import Spinner from 'react-bootstrap/Spinner';
import ColumnFilter from '../components/ColumnFilter';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';
import LeftMenu from '../components/LeftMenu';
import MycustomDesignGrid from '../components/MycustomDesignGrid';
import SettingsRightFilterToggle from '../components/Settings/SettingsRightFilterToggle';
import SettingsTopFilter from '../components/Settings/SettingsTopFilter';
import { ValidDate, formatNumnberWithComma, formatAmountWithComma, formatDate, toLocalDate } from '../components/Utlities'; 
import { format } from 'date-fns';

export default function VolumeByCustomer() {

    const [VolByCustomer, setVolByCustomer] = useState([]);
    const [DetailByCustCarr, setDetailData] = useState([]);
    const [selectedSummaryRow, setSelectedRow] = useState({});
    const [lastElement, setLastElement] = useState(null);
    const [hidden, setHidden] = useState(true);


    const [ownKey, setOwnerKey] = useState(0);
    const [custKey, setCustomerKey] = useState(0);


    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(1);

    const [prevY, setPrevY] = useState(0);
    const [dateDivVisible, setDateDivVisible] = useState(true); // State to control visibility

    let prevYRef = useRef({});
    let selectedRowRef = useRef({});
    let DetailByCustCarrRef = useRef({});
    let hiddenRef = useRef({});
    let pageRef = useRef({});

    prevYRef.current = prevY;
    selectedRowRef.current = selectedSummaryRow;
    DetailByCustCarrRef.current = DetailByCustCarr;
    hiddenRef.current = hidden;
    pageRef.current = page;

    const criData = [
        { criKey: 1, criValue: 'Owner' },
        { criKey: 2, criValue: 'Customer' },
        // { criKey: 2, criValue: 'Transportation Provider' },
        // { criKey: 3, criValue: 'Freight Bill Number' },
        // { criKey: 4, criValue: 'Transportation Provider Account Number' }
        // { criKey: 6, criValue: 'Division' },
    ];
    

    const searchOnClick = (ownerKey, customerKey, startDate, endDate) => {

        // debugger;
        setCustomerKey(customerKey);
        LoadSummaryData(ownerKey, customerKey, startDate, endDate);
    }


    const LoadSummaryData = async (ownerKey, customerKey, startDate, endDate) => {
        debugger;
        setLoading(true);
        setVolByCustomer([]);

        const URL = `${configData.BASE_APP_URL}VolumeByCustomer/GetVolumeByCustomer/${customerKey}/${ownerKey}/${startDate}/${endDate}`;
        console.log(URL);

        try {
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            const responseData = await response.json(); // Get JSON data from the API

            // Format the response data dynamically
            const formattedData = responseData.flatMap((item, index) => {
                const formattedServices = {
                    nvisionServices: item.nvisionServices.map(service => [service.serviceDescription]),
                    supplyChainServices: item.supplyChainServices.map(service => [service.serviceDescription]),
                    upsellServices: item.upsellServices.map(service => [service.serviceDescription]),
                    upsellDates: item.upsellServices.map(service => [service.sellDate]),
                    lostServices: item.lostServices.map(service => [service.serviceDescription]),
                    lostDates: item.lostServices.map(service => [service.lostDate]),
                };

                const rows = [];
                for (let i = 0; i < Math.max(formattedServices.nvisionServices.length, formattedServices.supplyChainServices.length, formattedServices.upsellServices.length, formattedServices.lostServices.length); i++) {
                    const row = {
                        Owner: i === 0 ? item.ownerName.trim() : '',
                        Customer: i === 0 ? item.customerName.trim() : '',
                        Activation_Date: i === 0 ? item.activationDate : '',
                        Freight_Volume_Total_Bills: i === 0 ? item.billCount : '',
                        Freight_Spend_Total_Paid_Amount: i === 0 ? item.paidAmount : '',
                        Services_Provided_By_nVision: formattedServices.nvisionServices[i] ? formattedServices.nvisionServices[i][0] : '',
                        Supply_Chain_Services: formattedServices.supplyChainServices[i] ? formattedServices.supplyChainServices[i][0] : '',
                        Upsells: formattedServices.upsellServices[i] ? formattedServices.upsellServices[i][0] : '',
                        Date_Of_Upsell: formattedServices.upsellDates[i] ? formattedServices.upsellDates[i][0] : '',
                        Business_Or_Portion_Of_Business_Lost: formattedServices.lostServices[i] ? formattedServices.lostServices[i][0] : '',
                        Date_Business_Or_Portion_Of_Business_Lost: formattedServices.lostDates[i] ? formattedServices.lostDates[i][0] : '',
                        Termination_Date: i === 0 ? item.terminationDate : '',
                        Date_Of_Last_Close: i === 0 ? item.lastCloseDate : '',
                    };
                    rows.push(row);
                }
                return rows;
            });

            console.log(formattedData); // Display formatted data in the console

            setVolByCustomer(formattedData);

            setLoading(false);
        } catch (error) {
            // Handle any errors here
            console.error("Error loading summary data:", error);
            setLoading(false);
        }
    };


    const DownloadSummaryData = async () => {

        const URL = `${configData.BASE_APP_URL}VolumeByCustomer/GenerateExcelForVolumeByCustomer`;
        console.log(URL);

        const response = await fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('my-token')
            },
            body: JSON.stringify({ data: VolByCustomer }),
            responseType: 'blob'
        });

        const data = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = `VOLUME BY CUSTOMER.xlsx`;
        link.click();

    };


    const AmountFormatter = (cell) => {
        if (cell === "" || cell === null) {
            return <span></span>; // Returning an empty span when serviceType is "CA"
        } else {
            // const formattedAmount = parseFloat(cell).toFixed(2).toLocaleString();
            const formattedAmount = cell.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return <span>{formattedAmount}</span>;
        }
    }


    const dateFormatter = (cell, row, rowIndex, formatExtraData) => {
        if (cell === "" || cell === null) {
            return <span></span>; // Returning an empty span when cell is blank or null
        } else {
            return (
                <span>{format(toLocalDate(cell), "MM/dd/yyyy")}</span>
            );
        }
    };

    const onCustomerChangeFilter = (selectedOwner, selectedCust, selectedFromDate, selectedToDate) => {
        debugger;
        if (selectedCust >= 0) {
            setOwnerKey(selectedOwner);
            setCustomerKey(selectedCust);
            setOwnerKey(selectedOwner);
            LoadSummaryData(selectedOwner, selectedCust, selectedFromDate, selectedToDate);
        }
        else {
            setVolByCustomer([]);
        }
    };

    const formatNumnber = (cell, row, rowIndex, formatExtraData) => {
        let result = cell;

        if (cell === null) {
            result = ''; // Convert null to blank
        }
        else {
            result = cell.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Formats as per locale (e.g., 454,879)
            
        }

        return result;
    }

    const columns = [
        {
            dataField: 'Owner',
            text: 'Owner',
            headerStyle: { width: '150px', textAlign: 'center' }
            // filter: customFilter(),
            // sort: true,
            // filterRenderer: (onFilter, column) =>
            //     <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'Customer',
            text: 'Customer',
            headerStyle: { width: '150px', textAlign: 'center' }
            // filter: customFilter(),
            // sort: true,
            // filterRenderer: (onFilter, column) =>
            //     <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'Activation_Date',
            text: 'Activation Date',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'left',
            formatter: dateFormatter,

        },
        {
            dataField: 'Freight_Volume_Total_Bills',
            text: 'Freight Volume Total Bills',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'right',
            formatter: formatNumnber,

        },
        {
            dataField: 'Freight_Spend_Total_Paid_Amount',
            text: 'Freight Spend Total Paid Amount',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'right',
            formatter: AmountFormatter

        },
        {
            dataField: 'Services_Provided_By_nVision',
            text: 'Services Provided By nVision Freight Bill Audit And Payment',
            headerStyle: { width: '200px', textAlign: 'center' },
            align: 'left'

        },
        {
            dataField: 'Supply_Chain_Services',
            text: 'Services Provided By nVision Supply Chain Services',
            headerStyle: { width: '200px', textAlign: 'center' },
            align: 'left'

        },
        {
            dataField: 'Upsells',
            text: 'Upsells',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'left',
        },
        {
            dataField: 'Date_Of_Upsell',
            text: 'Date Of Upsell',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'left',
            formatter: dateFormatter
        },
        {
            dataField: 'Business_Or_Portion_Of_Business_Lost',
            text: 'Business Or Portion Of Business Lost',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'left'

        },
        {
            dataField: 'Date_Business_Or_Portion_Of_Business_Lost',
            text: 'Date Business Or Portion Of Business Lost',
            headerStyle: { width: '150px', textAlign: 'center' },
            align: 'left',
            formatter: dateFormatter
        },
        {
            dataField: 'Termination_Date',
            text: 'Termination Date',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'left',
            formatter: dateFormatter
        },
        {
            dataField: 'Date_Of_Last_Close',
            text: 'Date Of Last Close',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'left',
            formatter: dateFormatter
        }

    ];


    const observer = useRef(
        new IntersectionObserver((entries, pagingOptioins) => {
            const first = entries[0];
            if (first.isIntersecting) {
                setPage((no) => no + 1);
            }
        })
    );

    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
      
    useEffect(() => {
        const currentElement = lastElement;
        const currentObserver = observer.current;

        if (currentElement) {
            currentObserver.observe(currentElement);
        }

        return () => {
            if (currentElement) {
                currentObserver.unobserve(currentElement);
            }
        };
    }, [lastElement]);

    const sizePerPageRenderer = ({
        options,
        currSizePerPage,
        onSizePerPageChange
    }) => (
        <div className="btn-group" role="group">
            {
                options.map((option) => {
                    const isSelect = currSizePerPage === `${option.page}`;
                    return (
                        <button
                            key={option.text}
                            type="button"
                            onClick={() => onSizePerPageChange(option.page)}
                            className={`btn ${isSelect ? 'btn-secondary' : 'btn-warning'}`}
                        >
                            {option.text}
                        </button>
                    );
                })
            }
        </div>
    );

    const options = {
        sizePerPageRenderer,
        sizePerPageList: [{
            text: '50', value: 50
        }, {
            text: '100', value: 100
        },
        {
            text: '200', value: 200
        }, {
            text: 'All', value: VolByCustomer.length
        }]
    };

    const breadcumTitle = <div dangerouslySetInnerHTML={{ __html: 'Volume By Customer' }} />;

    return (
        <>
            <div className='st1'>
                <LeftMenu />
                <div className="mcw">
                    <TopBar />
                    <div className='pt-1 px-3 pb-3 py-3'>

                        {/* <Breadcrumbs title="Invoices Processed By Character ( Top 10 Bills By Greatest Number of Character)" /> */}
                        <Breadcrumbs title={breadcumTitle} />
                        {loading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : loading}
                        <div className='sticky-top-content'>
                            <SettingsTopFilter oncustom={onCustomerChangeFilter} criData={criData} isDateDropdownHidden={false} />
                        </div>
                        {/* <div className='row mb-1'>
                            <div className='col-1 pe-0'>Top Bills</div>
                            <div className='col-2 topbills'>
                                <select id="topbills" onChange={onTopBillsSelect}>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                </select>
                            </div>
                        </div> */}

                        <div className='d-flex'>

                            <div className="table-container">
                                <div className='grid-toggle'>
                                    <div className='main-table-text dropup'>
                                        {VolByCustomer.length > 0 ?
                                            <ToolkitProvider
                                                keyField="freightBillKey"
                                                data={VolByCustomer}
                                                columns={columns}
                                                exportCSV>
                                                {
                                                    props => (
                                                        <div>
                                                            <div style={{ backgroundColor: '#fff', marginTop: '5px', textAlign: "right" }}>
                                                                <button className='btn react-bs-table-csv-btn' onClick={DownloadSummaryData}><i className='fa fa-download'></i> Export
                                                                </button>
                                                            </div>
                                                            <BootstrapTable
                                                                classes='table table-striped table-hover table-width'
                                                                headerClasses='table-top'
                                                                bootstrap4
                                                                pagination={paginationFactory(options)}
                                                                {...props.baseProps}
                                                                filter={filterFactory()}
                                                            />
                                                            {/* <button className='btn react-bs-table-csv-btn' onClick={DownloadSummaryData}><i className='fa fa-download'></i> Export</button> */}
                                                            {/* <ExportCSVButton {...props.csvProps}><i className='fa fa-download'></i> Export</ExportCSVButton> */}
                                                        </div>
                                                    )
                                                }
                                            </ToolkitProvider> : <>
                                                <MycustomDesignGrid column={columns} />
                                            </>}
                                    </div>
                                </div>
                            </div>
                            <SettingsRightFilterToggle onSearchClick={searchOnClick} dateDivVisible={dateDivVisible} />
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
}